import { createTypedSelector } from "../common/root-reducer-selector";
import { RootState } from "../types";

export const themeSelector = createTypedSelector(
  (state) => state,
  (state: RootState) => state.theme
);